import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });
}

export function formatDateTime(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function isDocumentExpiringSoon(expirationDate, daysThreshold = 30) {
  if (!expirationDate) return false;
  const exp = new Date(expirationDate);
  const now = new Date();
  const diffDays = Math.ceil((exp - now) / (1000 * 60 * 60 * 24));
  return diffDays <= daysThreshold && diffDays >= 0;
}

export function isDocumentExpired(expirationDate) {
  if (!expirationDate) return false;
  return new Date(expirationDate) < new Date();
}

export function getStatusColor(status) {
  const statusMap = {
    'ok': 'status-ok',
    'a_surveiller': 'status-warning',
    'en_maintenance': 'status-warning',
    'immobilise': 'status-danger',
    'en_attente': 'status-info',
    'en_cours': 'status-warning',
    'terminee': 'status-ok',
    'ouvert': 'status-danger',
    'resolu': 'status-ok',
    'ferme': 'status-info'
  };
  return statusMap[status] || 'status-info';
}

export function getStatusLabel(status) {
  const labels = {
    'ok': 'OK',
    'a_surveiller': 'À surveiller',
    'en_maintenance': 'En maintenance',
    'immobilise': 'Immobilisé',
    'en_attente': 'En attente',
    'en_cours': 'En cours',
    'terminee': 'Terminée',
    'annulee': 'Annulée',
    'ouvert': 'Ouvert',
    'resolu': 'Résolu',
    'ferme': 'Fermé'
  };
  return labels[status] || status;
}

export function getPriorityColor(priority) {
  const colors = {
    'haute': 'bg-red-100 text-red-800',
    'moyenne': 'bg-amber-100 text-amber-800',
    'basse': 'bg-green-100 text-green-800'
  };
  return colors[priority] || colors.moyenne;
}